import React from "react";
import InputMask from "react-input-mask";

class WizardItemForms extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			answer: this.props.data.Answer,
			errors: {},
			value: "",
			maskChar: "_",
			selectedCheckboxOptions: []
		};

		this.handleChange = this.handleChange.bind(this);
		this.validate = this.validate.bind(this);
		this.selectFieldToValidate = this.selectFieldToValidate.bind(this);
		this.stripStringFromCharacter = this.stripStringFromCharacter.bind(this);
		this.selectOption = this.selectOption.bind(this);
		this.arrayRemove = this.arrayRemove.bind(this);
	}

	componentWillMount() {
		let errorsObj = {};
		for (let i = 0; i < this.props.data.Fields.length; i++) {
			errorsObj[this.props.data.Fields[i].Id] = {
				error: this.props.data.Fields[i].IsMandatory,
				show: false
			};
		}
		this.setState({ errors: errorsObj });
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.currentAnswerError) {
			let newErrorsObj = Object.assign({}, this.state.errors);
			for (let key in newErrorsObj) {
				if (newErrorsObj[key].error) {
					newErrorsObj[key].show = true;
				}
			}
			this.setState({ errors: newErrorsObj });
		}
	}

	stripStringFromCharacter(str, char) {
		return str.split(char).join("");
	}

	arrayRemove(arr, value) { 
        return arr.filter(function(ele){ 
            return ele != value; 
        });
    }

	selectOption(e) {
		let id = e.target.value; //Id of the clicked checkbox
		let fieldId = e.target.dataset.fieldid;
		let currentSelectedCheckboxes = this.state.selectedCheckboxOptions;
		
		if(e.target.checked) {

			if(!currentSelectedCheckboxes.includes(id)) {
				currentSelectedCheckboxes.push(id);
			}

		}

		if(!e.target.checked) {
			if(currentSelectedCheckboxes.includes(id)) {
				currentSelectedCheckboxes = this.arrayRemove(currentSelectedCheckboxes, id);
			}
		}
		this.setState({ selectedCheckboxOptions: currentSelectedCheckboxes });


		this.setState({ selectedCheckboxOptions: currentSelectedCheckboxes	}, () => {
			//console.log("current state of answerArr AFTER checkbox is clicked: ", this.state.selectedCheckboxOptions);

			//ADD REMOVE COMPLETE
			//convert array to string
			let selectedCheckboxOptionsToString = ""
			if(this.state.selectedCheckboxOptions.length > 0) {
				selectedCheckboxOptionsToString = this.state.selectedCheckboxOptions.join();
			}


			let newAnswer = Object.assign([], this.state.answer);
			
			for (let i = 0; i < newAnswer.length; i++) {
				if (fieldId === newAnswer[i].FieldId) {
					newAnswer[i].Value = selectedCheckboxOptionsToString;
				}
			}
	
			this.setState({ answer: newAnswer });

			this.validate(fieldId, selectedCheckboxOptionsToString);
		});

	}

	handleChange(e) {
		let val = e.target.value;
		let id = e.target.id;

		if (e.target.getAttribute('data-has-mask')) {
			val = this.stripStringFromCharacter(val, this.state.maskChar)
		}
		
		let newAnswer = Object.assign([], this.state.answer);
		
		for (let i = 0; i < newAnswer.length; i++) {
			if (id === newAnswer[i].FieldId) {
				newAnswer[i].Value = val;
			}
		}
		
		this.setState({ answer: newAnswer });
	}

	selectFieldToValidate(e) {
		let id = e.target.id;
		let val = e.target.value;

		if (e.target.getAttribute('data-has-mask')) {
			val = this.stripStringFromCharacter(val, this.state.maskChar)
		}

		this.validate(id, val);
	}

	validate(id, val) {
		let field;
		let isValid = true;
		for (let i = 0; i < this.props.data.Fields.length; i++) {
			if (id === this.props.data.Fields[i].Id) {
				field = Object.assign({}, this.props.data.Fields[i]);
			}
		}

		if (field.IsMandatory && val.length === 0) {
			isValid = false;
		}

		if (field.ValidationRegEx && val.length > 0) { //Has regex
			let myRegEx = new RegExp(field.ValidationRegEx, "i");
			if (!myRegEx.exec(val)) { //Regex pass
				isValid = false;
			}
		}

		let newErrorsObj = Object.assign({}, this.state.errors);
		newErrorsObj[id].error = !isValid;
		newErrorsObj[id].show = !isValid;

		this.setState({ errors: newErrorsObj });

		//Check if a field contains an error - else return Answers to parent
		let errors = 0;

		for (let key in newErrorsObj) {
			if (newErrorsObj[key].error) {
				errors++;
			}
		}

		this.props.submitAnswer(this.state.answer);
	}

	setOptionValue(value, fieldId) {
		let newAnswer = Object.assign([], this.state.answer);
		
		for (let i = 0; i < newAnswer.length; i++) {
			if (fieldId === newAnswer[i].FieldId && !newAnswer[i].Value) {
				newAnswer[i].Value = value;
			}
		}
	}

	render() {

		const useTag = '<use xlink:href="/dist/svgsprite/icons.svg#Checkmark_16x16"/>';

		const fieldTypes = {
			TextField: "text",
			EmailField: "email",
			PhoneNumberField: "text",
			CheckboxListField: "checkbox"
		};
		
		return (
			<form>
                <div className="wizard-item wizard-item__forms">
                    {this.props.data.Fields.filter(field => (field.ItemType !== 'HiddenField' && field.ItemType !== 'UTMHiddenField')).map((field, idx) => {
                        
                        const extraClass = field.ItemType === "CheckboxListField" ? " wizard-item__forms__input--full-width" : "";
                        const answer = this.state.answer.find(answer => answer.FieldId === field.Id);
                        const answerValue = answer ? answer.Value : '';

                        return (
                            <div className={"wizard-item__forms__input" + extraClass} key={idx}>

                                {field.ItemType != "CheckboxListField" &&
                                    <label htmlFor={field.Id}>
                                        {field.PlaceholderText}
                                        {field.IsMandatory ? "*" : ""}
                                    </label>
                                }

                                {field.ItemType === "CheckboxListField" &&

                                    <div>

                                        <label>{field.Header}{field.IsMandatory ? "*" : ""}</label>

                                        {field.Options.map((option, idx) => {
                                            return (
                                                <div className="scform__checkbox" key={idx} >
                                                    <input
                                                        type={fieldTypes[field.ItemType]}
                                                        name={"inp-" + field.Id}
                                                        id={"rb-" + option.Id}
                                                        value={option.Id}
                                                        data-fieldid={field.Id}
                                                        onClick={this.selectOption}
                                                        required={field.IsMandatory}
                                                        data-trackingid={option.OptionTrackingId}
                                                        data-sc-field-name={field.FieldName}
                                                    />
                                                    <label htmlFor={"rb-" + option.Id}>{option.Header}</label>
                                                </div>
                                            )
                                        }
                                        )
                                        }
                                    </div>
                                }

                                {field.ItemType !== "CheckboxListField" && field.ItemType !== "DropdownListField" &&
                                    field.ItemType !== "MultiLineTextField" && field.InputMask.InputMask &&
                                    <InputMask
                                        mask={field.InputMask.InputMask}
                                        maskChar={this.state.maskChar}
                                        formatChars={{
                                            '8': '[1-9]',
                                            '9': '[0-9]',

                                            'a': '[A-Za-z]',
                                            '*': '[A-Za-z0-9]'
                                        }}
                                        data-has-mask={field.InputMask.InputMask ? true : false}
                                        id={field.Id}
                                        type={fieldTypes[field.ItemType]}
                                        placeholder={field.PlaceholderText}
                                        onChange={this.handleChange}
                                        value={answerValue}
                                        onBlur={this.selectFieldToValidate}
                                        required={field.IsMandatory}
                                        data-trackingid={field.QuestionTrackingId}
                                        data-sc-field-name={field.FieldName}
                                    />
                                }

                                {field.ItemType === "DropdownListField" &&
                                    <select
                                        id={field.Id}
                                        onChange={this.handleChange}
                                        required={field.IsMandatory}
                                        data-trackingid={field.QuestionTrackingId}
                                    >
                                        {field.Showemptyvalue &&
                                            <option className="option" label=" "></option>
                                        }
                                        {field.Options.map((option, idx) => {
                                            if (!field.Showemptyvalue && idx === 0) {
                                                this.setOptionValue(option.FieldValue, field.Id);
                                            }
                                            return (
                                                <option className="option" value={option.FieldValue} key={option.Id}>{option.FieldLabel}</option>
                                            )
                                        })}
                                    </select>
                                }

                                {field.ItemType === "MultiLineTextField" &&
                                    <textarea
                                        id={field.Id}
                                        placeholder={field.PlaceholderText}
                                        onChange={this.handleChange}
                                        value={answerValue}
                                        onBlur={this.selectFieldToValidate}
                                        required={field.IsMandatory}
                                        data-trackingid={field.QuestionTrackingId}
                                    />
                                }

                                {field.ItemType !== "MultiLineTextField" && field.ItemType !== "CheckboxListField" &&
                                    field.ItemType !== "DropdownListField" && !field.InputMask.InputMask &&
                                    <input
                                        data-has-mask={field.InputMask.InputMask}
                                        id={field.Id}
                                        type={fieldTypes[field.ItemType]}
                                        placeholder={field.PlaceholderText}
                                        onChange={this.handleChange}
                                        value={answerValue}
                                        onBlur={this.selectFieldToValidate}
                                        required={field.IsMandatory}
                                        data-trackingid={field.QuestionTrackingId}
                                        data-sc-field-name={field.FieldName}
                                    />
                                }

                                {typeof window !== "undefined" &&
                                    this.state.errors[field.Id].error &&
                                    this.state.errors[field.Id].show && (
                                        <div className="error">{field.ValidationErrorMessage}</div>
                                    )
                                }

                            </div>
                        );
                    })}
                </div>
			</form>
		);
	}
}

export default WizardItemForms;
